<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const BANNER_PATH = '/images/minha-carteira'

// One image per breakpoint, widest first: the browser picks the first source whose media matches.
const BANNER_SOURCES = [
  { minWidth: 1367, file: 'essential-breakpoint-1367+.svg' },
  { minWidth: 1280, file: 'essential-breakpoint-1280+.svg' },
  { minWidth: 1024, file: 'essential-breakpoint-1024+.svg' },
  { minWidth: 768, file: 'essential-breakpoint-768+.svg' },
]
const BANNER_FALLBACK_FILE = 'essential-breakpoint-375+.svg'
</script>

<template>
  <picture class="essential-banner">
    <source
      v-for="source in BANNER_SOURCES"
      :key="source.minWidth"
      :media="`(min-width: ${source.minWidth}px)`"
      :srcset="`${BANNER_PATH}/${source.file}`"
    >
    <img
      id="my-wallet-essential-banner"
      class="essential-banner-image"
      :src="`${BANNER_PATH}/${BANNER_FALLBACK_FILE}`"
      :alt="t('my_wallet.receiving_model.essential_banner.alt')"
    >
  </picture>
</template>

<style scoped lang="scss">
// The banner takes the height of the card beside it: the image is laid over the slot, so it adds no
// height of its own, and is cropped from the right (headline on the left stays visible).
.essential-banner {
  @apply relative block w-full min-w-0 overflow-hidden rounded-lg;

  .essential-banner-image {
    @apply absolute inset-0 block w-full h-full;
    object-fit: cover;
    object-position: left center;
  }
}
</style>
